import { InputAdornment, TextField } from '@mui/material';
import { IRON } from 'styles/Colors';
import { makeAnimationStartHandler } from 'sharedActions/sharedActions';
import { noop } from 'lodash';
import {
  validPasswordCase,
  validPasswordEmail,
  validPasswordLength,
  validPasswordNumber,
  validPasswordSpecialChars
} from 'reg_redesign/helper';
import PasswordRequirements from 'components/component_lib/PasswordRequirements';
import React, { useEffect, useState } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

export const validationText = [
  {
    rule: validPasswordLength,
    displayValue: 'Must be at least 12 characters'
  },
  {
    rule: validPasswordNumber,
    displayValue: 'Must contain at least one number'
  },
  {
    rule: validPasswordSpecialChars,
    displayValue: 'Must contain at least one special character (@$!%*#?& )'
  },
  {
    rule: validPasswordCase,
    displayValue: 'Mix of both upper and lower case letters'
  },
  {
    rule: validPasswordEmail,
    displayValue: 'Cannot contain your email address'
  }
];

export default function Password({
  additionalProp,
  onChange = noop,
  onMount = noop,
  onSubmit = noop,
  value,
  error = ''
}) {
  const [passwordHidden, setPasswordHidden] = useState(true);
  const [touched, setTouched] = useState(false);
  const [passwordHasValue, setPasswordHasValue] = useState(false);

  useEffect(() => {
    onMount(value, validationText, false);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    if (val !== '') {
      setPasswordHasValue(true);
    } else {
      setPasswordHasValue(false);
    }

    onChange(val, validationText, touched);
  };

  const handleOnBlur = () => {
    setTouched(true);
    onChange(value, validationText, touched);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit(); // Trigger form submission on Enter key press
    }
  };

  return (
    <div>
      <TextField
        id='password'
        label='Password'
        type={passwordHidden ? 'password' : 'text'}
        variant='outlined'
        value={value}
        InputLabelProps={{ style: { color: IRON }, shrink: passwordHasValue }}
        onFocus={() => {
          setTouched(true);
        }}
        FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              {passwordHidden ? (
                <VisibilityIcon onClick={() => setPasswordHidden(false)} />
              ) : (
                <VisibilityOffIcon onClick={() => setPasswordHidden(true)} />
              )}
            </InputAdornment>
          ),
          onAnimationStart: makeAnimationStartHandler(setPasswordHasValue)
        }}
        onChange={handleChange}
        onBlur={handleOnBlur}
        onKeyDown={handleKeyDown}
        error={!!error}
        helperText={error}
        fullWidth
        formControlStyle={{ width: '100%' }}
      />

      {!additionalProp?.hideRequirements && (
        <PasswordRequirements rules={additionalProp?.validationsDisplay} />
      )}
    </div>
  );
}
